import { render, staticRenderFns } from "./ImageSpinner.vue?vue&type=template&id=60d6f633&"
import script from "./ImageSpinner.vue?vue&type=script&lang=js&"
export * from "./ImageSpinner.vue?vue&type=script&lang=js&"
import style0 from "./ImageSpinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports